/**
 * @file
 * Metadata.
 */

import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueMobileDetection from 'vue-mobile-detection';

Vue.use(VueMeta);
Vue.use(VueMobileDetection);
